import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowSmallDownMini = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12 6C12.2387 6 12.4676 6.09482 12.6364 6.2636C12.8052 6.43239 12.9 6.66131 12.9 6.9V14.8656L15.252 12.276C15.3329 12.1868 15.4309 12.1147 15.5402 12.0641C15.6495 12.0134 15.7678 11.9853 15.8882 11.9812C16.0086 11.9771 16.1286 11.9973 16.241 12.0404C16.3535 12.0836 16.4561 12.1488 16.5429 12.2324C16.6297 12.3159 16.6988 12.416 16.7461 12.5268C16.7935 12.6375 16.8181 12.7567 16.8186 12.8771C16.8191 12.9976 16.7954 13.1169 16.7489 13.228C16.7024 13.3391 16.6341 13.4398 16.548 13.524L12.648 17.724C12.5641 17.8111 12.4634 17.8804 12.3521 17.9277C12.2407 17.975 12.121 17.9994 12 17.9994C11.879 17.9994 11.7593 17.975 11.648 17.9277C11.5366 17.8804 11.436 17.8111 11.352 17.724L7.45201 13.524C7.36591 13.4398 7.2976 13.3391 7.25111 13.228C7.20463 13.1169 7.18093 12.9976 7.1814 12.8771C7.18188 12.7567 7.20653 12.6375 7.25389 12.5268C7.30125 12.416 7.37036 12.3159 7.45712 12.2324C7.54388 12.1488 7.64653 12.0836 7.75898 12.0404C7.87144 11.9973 7.99141 11.9771 8.11179 11.9812C8.23217 11.9853 8.35051 12.0134 8.45979 12.0641C8.56908 12.1147 8.66708 12.1868 8.74801 12.276L11.1 14.8656V6.9C11.1 6.66131 11.1948 6.43239 11.3636 6.2636C11.5324 6.09482 11.7613 6 12 6Z",
		fill: "currentcolor"
	})]
});
export default SvgArrowSmallDownMini;
